var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeShowBooths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3faff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59,48.36c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1,48.36c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.64,51.81c-.08,0-.17-.01-.25-.04l-19.57-6.83s-.05-.01-.08-.02l-9.63-3.34c-.39-.14-.6-.56-.46-.96.14-.39.56-.59.95-.46l9.57,3.32s.05.01.08.02l19.63,6.85c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.29,55.26c-.08,0-.17-.01-.25-.04l-29.5-10.29c-.31-.09-.53-.38-.53-.72,0-.41.33-.75.74-.75h.02c.08,0,.17.01.25.04l29.52,10.3c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.36,51.81c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l19.64-6.85s.06-.02.08-.02l9.55-3.32c.39-.14.82.07.95.46.14.39-.07.82-.46.95l-9.62,3.34s-.05.02-.08.02l-19.58,6.83c-.08.03-.17.04-.25.04Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.71,55.26c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l29.52-10.3c.47-.16,1,.21,1.01.71,0,.36-.25.66-.58.73l-29.45,10.28c-.08.03-.17.04-.25.04Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.99,48.36c-.08,0-.17-.01-.25-.04l-28.75-10.02L1.25,48.31c-.39.14-.82-.07-.95-.46-.14-.39.07-.82.46-.96l28.99-10.1c.16-.06.33-.06.49,0l28.99,10.1c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,59.04c-.09,0-.18-.02-.26-.05L.74,48.31c-.29-.11-.48-.38-.49-.68,0-.31.17-.59.45-.71.2-.08.41-.08.6,0l28.7,10.57,28.67-10.56c.19-.09.41-.11.62-.02.28.12.47.4.46.71,0,.31-.2.58-.49.69l-29,10.68c-.08.03-.17.05-.26.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.37,25.75c-.41,0-.75-.34-.75-.75V7.68c0-.41.34-.75.75-.75s.75.34.75.75v17.32c0,.41-.34.75-.75.75Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.63,31.57c-.41,0-.75-.34-.75-.75v-13.44c0-.41.34-.75.75-.75s.75.34.75.75v13.44c0,.41-.34.75-.75.75Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.96,13.44c-1.14,0-2.28-.3-3.29-.91l-.74-.45-.74.45c-2.03,1.22-4.55,1.22-6.59,0l-1.49-.9v-7.63h33.79v7.63l-1.49.9c-2.03,1.22-4.56,1.22-6.59,0l-.74-.45-.74.45c-2.03,1.22-4.56,1.22-6.59,0l-.74-.45-.74.45c-1.02.61-2.15.91-3.29.91Zm-4.04-3.11l1.51.91c1.55.93,3.49.93,5.04,0l1.51-.91,1.52.91c1.55.93,3.49.93,5.04,0l1.51-.91,1.52.91c1.55.93,3.49.93,5.04,0l.76-.46v-5.28H14.61v5.28l.77.46c1.55.93,3.49.93,5.04,0l1.51-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.28,33.75H14.72v-13.61h30.56v13.61Zm-29.06-1.5h27.56v-10.61h-27.56v10.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.14,
    y: 13.63,
    width: 1.5,
    height: 7.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.36,
    y: 13.63,
    width: 1.5,
    height: 7.26
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeShowBooths);
export default __webpack_public_path__ + "static/media/Trade Show Booths.876792400c733b7637cb827e4e1ee699.svg";
export { ForwardRef as ReactComponent };